import { render, staticRenderFns } from "./h1.vue?vue&type=template&id=822b4fc4&"
import script from "./h1.vue?vue&type=script&lang=ts&"
export * from "./h1.vue?vue&type=script&lang=ts&"
import style0 from "./h1.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports